import React from "react";
import {
  Box,
  Input,
  FormControl,
  InputLabel,
  FormHelperText,
  TextField,
} from "@mui/material";
import { AccountCircle } from "@mui/icons-material";
import { CurrencyInput } from "react-currency-mask";

interface Props {
  value?: string | number | Date;
  onChange(value: string, name: string): void;
  error?: boolean;
  hasIcon?: boolean;
  inputName: string;
  placeholder: string;
  width?: string;
  errorMessage?: string | any;
  inputType?: "text" | "password" | "email" | "number" | "date" | "textField";
  disabled?: boolean;
  startAdornment?: any;
  endAdornment?: any;
  defaultValue?: string | number;
  multiline?: boolean;
  hasMoneyMask?: boolean;
}

export function GenericInput({
  value,
  onChange,
  error,
  hasIcon = true,
  inputName,
  placeholder,
  width = "100%",
  errorMessage,
  inputType = "text",
  disabled = false,
  startAdornment = null,
  endAdornment = null,
  defaultValue,
  multiline = false,
  hasMoneyMask = false,
}: Props) {
  const onChangeValue = (
    e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    originalValue?: any
  ) => {
    const target = e.target as HTMLInputElement;
    if (hasMoneyMask) {
      const removeDotsRegex = new RegExp("[^a-z0-9_]+");
      const removeDots = String(originalValue).replace(removeDotsRegex, "");

      onChange(removeDots, target.name);
    }
    if (inputName === "phone" || inputName === "ssn") {
      return onChange(target.value.replace(/\D/g, ""), target.name);
    }
    onChange(target.value, target.name);
  };

  const getDefaultValue = () => {
    const convertToString = String(defaultValue);
    const getLength = convertToString.length;
    const finalDigits = `${convertToString[getLength - 2]}${
      convertToString[getLength - 1]
    }`;
    const removeFinalDigits = convertToString.slice(0, -2);
    const createNumber = `${removeFinalDigits}.${finalDigits}`;
    return Number(createNumber);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: width,
      }}
    >
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        width={"100%"}
      >
        {hasIcon && (
          <AccountCircle sx={{ color: "action.active", mr: 1, my: 0.5 }} />
        )}

        <FormControl fullWidth sx={{ m: 1 }} variant="standard">
          {!hasMoneyMask && (
            <InputLabel htmlFor={`standard-adornment-${inputName}`}>
              {placeholder}
            </InputLabel>
          )}
          {hasMoneyMask ? (
            <CurrencyInput
              onChangeValue={(event, originalValue, mask) => {
                if (
                  String(mask).split(",")[1] === "00" &&
                  originalValue !== 0
                ) {
                  onChangeValue(event, Number(originalValue) * 100);
                } else if (String(mask).split(",")[1][1] === "0") {
                  onChangeValue(event, Number(originalValue) * 100);
                } else {
                  onChangeValue(event, originalValue);
                }
              }}
              defaultValue={getDefaultValue()}
              InputElement={
                <TextField
                  label={placeholder}
                  variant="standard"
                  multiline={multiline}
                  id={`standard-adornment-${inputName}`}
                  type="text"
                  name={inputName}
                  error={error}
                  disabled={disabled}
                />
              }
            />
          ) : (
            <Input
              multiline={multiline}
              endAdornment={endAdornment}
              id={`standard-adornment-${inputName}`}
              type={inputType}
              value={value}
              name={inputName}
              onChange={onChangeValue}
              error={error}
              disabled={disabled}
              startAdornment={startAdornment}
              defaultValue={defaultValue}
            />
          )}
        </FormControl>
      </Box>
      <FormHelperText error>{errorMessage}</FormHelperText>
    </Box>
  );
}
